import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpBulkUploadService } from '../../../service/http-bulk-upload.service';
import { HttpFileService } from '../../../service/http-file.service';
import { BulkUploadDto } from '../../../service/dto';
import { Router } from '@angular/router';

@Component({
	selector: 'app-member-bulk-upload-list',
	standalone: false,
	templateUrl: './member-bulk-upload-list.component.html',
	styleUrl: './member-bulk-upload-list.component.scss'
})
export class MemberBulkUploadListComponent implements OnInit, OnDestroy {
	data: BulkUploadDto[] = [];
	constructor(private httpBulkUploadService: HttpBulkUploadService, private httpFileService: HttpFileService, private router: Router) {

	}

	ngOnInit() {
		this.httpBulkUploadService.getAll("Member").subscribe(result => this.data = result);
	}
	ngOnDestroy() {

	}

	doView(input: BulkUploadDto) {
		this.router.navigate(['/member','bulk',input.id,'view']);
	}
}
